import React, { useRef, useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { toast } from "react-toastify"

import { Spinner, } from "components"
import { createPrintRequest } from "utils"
import classes from "./PvPrintButton.module.scss"

const PvPrintButton = (props) => {
  const {
    printType,
    printData,
    selectedPaperWidth,
    selectedPrinterResolution
  } = props

  const printers =
    useSelector(state => state.printers)

  const [loading, setLoading] = useState(false)

  const unmount = useRef(false)

  const handlePrint = async () => {
    const printerSettings = printers[0]

    if (!printerSettings) {
      return toast.error("هیچ پرینتری یافت نشد")
    }

    setLoading(true)

    const request = {
      printType,
      printData,
      printerIndex: 0,
      saveToFailedPrints: false,
      printerSettings: {
        ...printerSettings,
        printerPaperWidth: selectedPaperWidth,
        printerResolution: selectedPrinterResolution
      }
    }

    try {
      await createPrintRequest(request)
    } catch (err) {
      console.log(err)
    }

    if (unmount.current) return

    setLoading(false)
  }

  useEffect(() => {
    unmount.current = false

    return () => { unmount.current = true }
  }, [])

  return (
    <button
      disabled={loading}
      onClick={handlePrint}
      className={classes["footer"]}
    >
      {!loading
        ?
        <span className={classes["footerText"]}>
          تست
        </span>
        :
        <Spinner
          color="white"
          size={16}
        />
      }
    </button>
  )
}

export default PvPrintButton